import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {$agentsFactory} from "../../$agents.factory";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DemandAccountType} from "../../../account/types/demand-account.type";

export class AgentsPendingListViewCtrl implements IController {

  agent: AgentModel;

  score: any;
  onAssign: Function;

  private agentsRef: any;
  private loading: boolean;
  private queryString: any;
  private accountTypes: string[];

  constructor(private $log, private agentRequests: AgentRequests, private confirmDialogService: ConfirmDialogService, private commonsAlertsService: CommonsAlertsService, private $stateParams,
              private agentsAlerts: AgentsAlerts, private accountDialogService: AccountDialogService, private $agents: $agentsFactory, private $state) {
  }

  $onInit() {
    this.accountTypes = Object.values(DemandAccountType);

    this.agentsRef = this.$agents();
    this.loading = false;
  }

  submitQuery(queryString) {
    this.queryString = queryString;
  }

  exportAgents(event) {
    this.confirmDialogService.confirm('Pending agents export', 'This action will export all pending agents to detailed excel report', event)
      .then(() => {
          this.agentRequests.exportPending()
            .then(() => {
              this.commonsAlertsService.exportToMailSuccess();
            })
            .catch((error) => {
              this.commonsAlertsService.exportToMailError();
            })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreateAgent(event) {
    this.accountDialogService.createNewCarrier(event, this.accountTypes)
      .then((agentToCreate) => {
        this.loading = true;
        return this.agentsRef.$put(agentToCreate);
      })
      .then((createdAgent) => {
        this.agentsAlerts.createSuccess();
        this.$state.go('agent.agent-profile', _.assign({}, this.$stateParams, {id: createdAgent.id, createdAgent: createdAgent}));
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.createError(error);
          this.$log.error('Failed to create agent @agentsPendingListView@onCreateAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsPendingListView', {
    bindings: {},
    template: require('./agents-pending-list-view.html').default,
    controller: AgentsPendingListViewCtrl
  });
